import { Link } from 'react-router-dom';
import styled from 'styled-components';
import elevateLogo from '@/assets/logo.svg';
import { media } from '@/Shared/theme';

const StyledLogo = styled.img<{ $hasImage: boolean }>`
	max-height: 36px;
	max-width: ${(props) => (props.$hasImage ? '120px' : '90px')};

	${media.smallScreen} {
		max-height: 46px;
		max-width: ${(props) => (props.$hasImage ? '200px' : '120px')};
	}
`;

interface LogoProps {
	logoUrl: string;
}

const Logo = ({ logoUrl }: LogoProps) => {
	const src = logoUrl === '' ? elevateLogo : logoUrl;

	return (
		<Link to="/" className="logo-link">
			<StyledLogo src={`${src}`} $hasImage={logoUrl !== ''} alt="school logo" className="logo" />
		</Link>
	);
};

export default Logo;
